import { currentDeployment } from '../lib/deployment';

/**
 * A small, loud label saying this is not the live site.
 *
 * Renders nothing at all on production, which is the whole design: see
 * deployment.ts for why silence there is the point.
 */
export function EnvBadge({ className }: { className?: string }) {
  const label = currentDeployment();
  if (!label) return null;
  return (
    <span className={className ? `env-badge ${className}` : 'env-badge'} role="status">
      {label}
      {/* Said once, in words, for anyone who does not read a coloured pill as
          meaning anything — including somebody who has never seen the live
          site and has no idea this one is different. */}
      <span className="env-badge-note">not the live site</span>
    </span>
  );
}
